// pages/CommonDocumentsPage.tsx

import React, { useEffect, useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  TextField,
  InputAdornment,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { Grid } from "@material-ui/core";
import BreadcrumbComp from "../CommonComponents/Breadcrumb/Breadcrumb";
import Datatable from "../CommonComponents/Datatable/Datatable";
import { DocumentListData } from "../../helpers/renderData";
import { deleteDocument, downloadDocumentFile, GetAllDocument } from "../../services/Documentservice";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import { connect } from "react-redux";
import { toastAlert } from "../../helpers/toastAlert";
import ConfirmDeleteModal from "../CommonComponents/Confrimationmodal";
import { FilePreviewDrawer } from "../CommonComponents/FilePreview";

const DocumentAllList = (props) => {
  const [tableData, setTableData] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [searchText, setSearchText] = useState("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState("");
  const [previewDoc, setPreviewDoc] = useState(null);

  const handleonRowClick = (doc) => {
    setPreviewDoc(doc);
  };
  const handleDownload = async (doc) => {
    try {
      await downloadDocumentFile(
        doc._id,
        props?.authData?.accessToken,
        doc.fileName || "document",
      );
      toastAlert("Download started", "success");
    } catch (err) {
      toastAlert(err?.message || "Download failed", "error");
    }
  };
  const openDeleteModal = (id) => {
    setDeleteId(id);
    setShowDeleteModal(true);
  };

  const confirmDelete = async () => {
    try {
      await deleteDocument(props ,deleteId);
      toastAlert("Document deleted successfully", "success");
      setShowDeleteModal(false);
      setDeleteId("");
      loadData();
    } catch (err) {
      toastAlert("Delete failed", "error");
    }
  };

  const itemArray = () => [
    {
      name: "All Documents",
      active: true,
      link: "",
    },
  ];
  useEffect(() => {
    loadData();
  }, [currentPage, searchText, rowsPerPage]);
  const loadData = async () => {
    const response = await GetAllDocument(
      props,
      currentPage,
      rowsPerPage,
      searchText,
    );
    const data = await DocumentListData(response?.data?.documents || [], {
      handleonRowClick,
      handleDownload,
      openDeleteModal,
    });
    setTableData(data);
    setTotalRows(response?.data?.total || 0);
  };
  return (
    <div>
      <Grid item lg={12} sm={12} xs={12} md={12}>
        <BreadcrumbComp items={itemArray()} />
      </Grid>

      {/* Add Button */}
      <Grid container>
        <Grid
          item
          lg={12}
          sm={12}
          md={12}
          xs={12}
          xl={12}
          style={{ textAlign: "end" }}
        ></Grid>
      </Grid>

      {/* DataTable */}
      <Grid container className="data-table-main">
        <Grid item lg={12} sm={12} md={12} xs={12}>
          <div className="card-main" style={{ width: "100%" }}>
            <Datatable
              props={tableData}
              title="All Documents"
              currentPage={currentPage}
              TotalRow={totalRows}
              rowsPerPage={rowsPerPage}
              onPageChange={(page, rows) => {
                setCurrentPage(page);
                setRowsPerPage(rows);
              }}
              onSearchChange={(search) => {
                setSearchText(search);
                setCurrentPage(1);
              }}
            />
          </div>
        </Grid>
      </Grid>
       <ConfirmDeleteModal
              open={showDeleteModal}
              onClose={() => setShowDeleteModal(false)}
              onConfirm={confirmDelete}
              message="Are you sure you want to delete this Document?"
            />
      <FilePreviewDrawer document={previewDoc} onClose={() => setPreviewDoc(null)} />
    </div>
  );
};

const mapStateToProps = (state) => ({
  authData: state.authReducer,
});

export default withRouter(connect(mapStateToProps)(DocumentAllList));
